import React from 'react';
import { Link } from 'react-router-dom';
import type { KpisResponse } from '../types';
import KpiCard from './KpiCard';

export default function RetentionSummarySection({
  retention,
  detailHref,
  canOpenDetail = true,
}: {
  retention?: KpisResponse['retentionSummary'];
  detailHref: string;
  canOpenDetail?: boolean;
}) {
  const rows = (retention?.rows || []).filter((row) => row.baseYear === 2024 || row.baseYear === 2025);
  if (!rows.length) return null;

  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 900 }}>Retention & Churn</div>
          <div className="muted" style={{ fontSize: 12 }}>
            Main dashboard view for cohorts 2024 → 2025 and 2025 → 2026.
          </div>
        </div>
        {canOpenDetail ? (
          <Link className="btn" to={detailHref}>
            Open detail
          </Link>
        ) : null}
      </div>
      {rows.map((row, index) => (
        <React.Fragment key={row.year}>
          <div style={{ height: 12 }} />
          <div style={{ fontSize: 14, fontWeight: 800 }}>{row.baseYear} → {row.year}</div>
          <div style={{ height: 10 }} />
          <div className="grid kpis">
            <KpiCard title="NRR" value={row.nrr} format="percentage" />
            <KpiCard title="GRR" value={row.grr} format="percentage" />
            <KpiCard title="Logo Churn" value={row.logoChurnRate} format="percentage" />
          </div>
          {index < rows.length - 1 ? <div className="hr" /> : null}
        </React.Fragment>
      ))}
    </div>
  );
}
